export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 80,
    visible: !that.disabled,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_shipmentPayStatementNo') || '付款结算单编号',
    field: 'shipmentPayStatementNo',
    width: 135,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    visible: that.disabled,
    fixed: 'left',
  },
  {
    title: that.$l('table_label_shipmentContractNo') || '外运编号',
    field: 'shipmentContractNo',
    minWidth: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_shipmentPlanNo') || '发运单编号',
    field: 'shipmentNo',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_totalBookingVolume') || '订舱总体积',
    field: 'totalBookingVolume',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_share_amount') || '分摊金额',
    field: 'shareAmount',
    align: 'center',
    minWidth: 180,
    editRender: {
      name: 'ElInputNumber',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入',
        precision: 2,
        min: 0,
        step: 0.01,
        'controls-position': 'right',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
    isTotalColumn: true,
  },
  {
    title: that.$l('INDEX.item_label_orgDepFullName') || '分摊部门',
    field: 'orgDepFullName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 300,
    editRender: { enable: true },
    slots: { edit: 'depCode' },
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
